import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DittaComponent } from './ditta.component';
import { DittaEditComponent } from './ditta-edit/ditta-edit.component';
import { DittaCreateComponent } from './ditta-create/ditta-create.component';
import { DittaDetailsComponent } from './ditta-details/ditta-details.component';

const routes: Routes = [{
  path: '', component: DittaComponent, children:[
    {path: 'edit/:id',
     component:DittaEditComponent
  },
    {path: 'create/:id', 
   component:DittaCreateComponent
  },
    {path: 'details/:id', 
    component:DittaDetailsComponent
  }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DittaRoutingModule { }
